export default __webpack_public_path__ + "static/media/CongratLetter2025.c66bd55b.pdf";